
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Registering necessary components in Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

// generateChartData.js
export const generateChartData = (rawData) => {
    const labels = rawData.map(item => item[0]);
    const dataValues = rawData.map(item => item[1]);
    const additionalData = rawData.map(item => item[2]); // Capture the additional data (e.g., lab numbers)
  
    return {
      labels: labels,
      datasets: [
        {
          label: 'Result',
          data: dataValues,
          borderColor: 'transparent',
          backgroundColor: 'transparent',
          fill: false,
          pointRadius: 7,
          pointBackgroundColor: '#04559f',
          borderWidth: 0,
          pointHoverRadius: 7,
          pointHoverBackgroundColor: '#fec553',
          datalabels: {
            color: '#000',
            font: { size: 12, weight: 'bold' },
            align: 'top',
            anchor: 'end',  
            borderRadius: 5,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            clip: false, 
           
          //  padding: ,
          },
        },
      ],
      additionalData, // Pass the additional data for use in tooltip callbacks
    };
  };

  
  
  